import { Typography } from "antd";
import { FC, useMemo } from "react";
import { AnyTask, Market, TaskRoute } from "tm-shared/types";

import FlexContainer from "@/components/FlexContainer";
import { MarketActionsBar } from "@/components/ItemListView/MarketActionsBar";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { ImageRowList } from "@/components/UI/ImageRowList";
import { ASSIGNMENT_VOCABULARY } from "@/constants/ui/assignment";
import { AssignmentWithContext } from "@/pages/Assignments/AssignmentsPage/AssignmentPage.types";
import { MarketTasks } from "@/pages/WorkPlan/components/MarketTasks";

import { StyledDivider } from "./Styled";

interface AssignmentBodyProps {
    item: AssignmentWithContext;
    onOpenTasksInfoModal: (params: { task: AnyTask; market: Market }) => void;
}

export const AssignmentBody: FC<AssignmentBodyProps> = ({
    item,
    onOpenTasksInfoModal,
}) => {
    const { assignment, allTasks, market } = item;

    const marketToCopy = useMemo(
        () => ({
            id: market.id,
            name: market.name,
            externalMarketId: market.externalMarketId,
            address: market.address,
            partner: market.partner.name,
            partnerId: market.partner.id,
            type: market.type,
            category: market.category,
            fop: market.contragent.name,
            hasDebt: market.hasDebt,
            hasDebtCritical: market.hasDebtCritical,
        }),
        [market],
    );

    const marketTasks = useMemo(() => Object.values(allTasks), [allTasks]);

    const incompleteRoutes = useMemo(() => {
        const set = new Set<TaskRoute>();
        for (const t of marketTasks) {
            if (!t.completed) set.add(t.context.route);
        }
        return set;
    }, [marketTasks]);

    return (
        <FlexContainer
            flexDirection="column"
            alignItems="flex-start"
            gap="16px"
        >
            <MarketActionsBar
                marketId={market.id}
                marketName={market.name}
                geo={market.geo}
                address={market.address?.name}
                objToCopy={marketToCopy}
            />
            <FlexContainer
                flexDirection="column"
                gap="8px"
                alignItems="flex-start"
            >
                <FlexContainer justifyContent="flex-start" gap="8px">
                    <SecondaryText color="disabled">
                        Тип доручення:
                    </SecondaryText>
                    <PrimaryText>
                        {
                            ASSIGNMENT_VOCABULARY?.[
                                assignment.context.additionalData.assignmentType
                            ]?.label
                        }
                    </PrimaryText>
                </FlexContainer>

                <Typography
                    dangerouslySetInnerHTML={{
                        __html: assignment.context.description,
                    }}
                />
            </FlexContainer>

            <ImageRowList images={assignment.context.files ?? []} />

            <StyledDivider />

            <MarketTasks
                tasks={marketTasks}
                market={market}
                incompleteRoutes={incompleteRoutes}
                onOpenTasksInfoModal={onOpenTasksInfoModal}
                readonly
            />
        </FlexContainer>
    );
};
